import React, { useState } from "react";
import "../../index.css";
import "../../App.css";
import { Row, Radio, Typography } from "antd";
import { painEntryFormConstants } from "../../helpers/painEntryFormConstants";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "./../../redux-toolkit/store/store";
import { handleUpdateMoodLevel } from "../../redux-toolkit/slices/painEntryFormSlice";
const TeMoodLevel = () => {
  const moodLevel = useSelector(
    (state: RootState) => state.painEntryForm.moodLevel
  );
  const dispatch = useDispatch();
  const handleSelect = (value: string) => {
    dispatch(handleUpdateMoodLevel(value));
  };

  return (
    <div className="flex flex-col gap-2">
      <label className="h6 text-theme-text-secondary">
        <strong>Mood Level *</strong>
      </label>
      <p className="body1 text-theme-text-primary mb-4">
        Select the option that best describes your current mood level.
      </p>
      <Radio.Group
        onChange={(e) => handleSelect(e.target.value)}
        value={moodLevel}
      >
        {painEntryFormConstants.moodLevels.map(({ value, label }) => {
          return (
            <Radio key={value} value={value}>
              {label}
            </Radio>
          );
        })}
      </Radio.Group>
    </div>
  );
};

export default TeMoodLevel;
